<template>
  <div>
    <Header></Header>
    <div class="ui container">
      <div id="" class="ui icon  ">
        <div class="content">
          <div class="header"></div>
        </div>
      </div>
      <form class="ui form">
        <div class="field">
          <label>Question</label>
          <textarea
            type="text"
            rows="3"
            v-model="this.question"
            placeholder="Question"
          >
          </textarea>
        </div>
        <div class="field">
          <label>Answer</label>
          <textarea
            type="text"
            v-model="this.answer"
            placeholder="Answer"
          ></textarea>
        </div>
        <div class="field">
          <label>Page URL</label>
          <input type="text" v-model="this.pageURL" placeholder="Page URL" />
        </div>
        <div class="field">
          <div class="ui toggle checkbox">
            <input
              type="checkbox"
              name="profile[email_not]"
              true-value="1"
              false-value="0"
            />
            <label>Hide Record From Feed?</label>
          </div>
        </div>

        <div class="field"></div>
        <div class="field">
          <div class="inline fields">
            <label>Category</label>
            <div class="field">
              <div class="ui checkbox">
                <input type="checkbox" name="profile[un-categorized]" />
                <label>Un-categorized</label>
              </div>
            </div>
            <div class="field">
              <div class="ui checkbox">
                <input type="checkbox" name="profile[support]" />
                <label>Support</label>
              </div>
            </div>
          </div>
        </div>
        <div class="field">
          <label>Expiration Date</label>
          <input class="ui calendar" type="date" v-model="this.expiry_date" />
        </div>
        <div class="field">
          <label>Expiration Hour</label>
          <select
            v-model="expiry_hour"
            class="ui dropdown gender"
            name="questionHour"
          >
            <option v-for="hour in hours" :key="hour" :selected="expiry_hour === hour">{{
              hour
            }}</option>
          </select>
        </div>
        <div class="ui form">
          <div class="inline fields">
            <label>Question type</label>
            <div class="field">
              <div class="ui radio checkbox">
                <input type="radio" name="profile[access]" value="private" v-model="questionType" />
                <label>Private</label>
              </div>
            </div>
            <div class="field">
              <div class="ui radio checkbox">
                <input type="radio" name="profile[access]" value="public" v-model="questionType"/>
                <label>Public</label>
              </div>
            </div>
            <div class="field">
              <div class="ui radio checkbox">
                <input type="radio" name="profile[access]" value="greeting" v-model="questionType"/>
                <label>Greeting</label>
              </div>
            </div>
            <div class="field">
              <div class="ui radio checkbox">
                <input type="radio" name="profile[access]" value="queryback" v-model="questionType"/>
                <label>Query Back</label>
              </div>
            </div>
          </div>
        </div>

        <router-link class="ui button" to="/qarecord">Cancel</router-link>
        <span class="ui button blue" @click="this.updateQuestion"> Save</span>
      </form>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";

export default {
  name: "qaedit",
  components: { Header },
  data() {
    return {
      id: 0,
      question: "",
      answer: "",
      pageURL: "",
      questionType: "",
      expiry_date: "",
      expiry_hour: "",
      record_feed: 0,
      hours: Array.from({ length: 24 }, (v, i) => i).slice(0)
    };
  },
  methods: {
    updateQuestion() {

      this.axios
        .post(this.$store.state.apiUrl + "Update/updateQuestion.php", {
          token: localStorage.getItem("token"),
          question: this.question,
          answer: this.answer,
          pageURL: this.pageURL,
          questionType: this.questionType,
          expiry_date: this.expiry_date,
          expiry_hour: this.expiry_hour,
          record_feed: this.record_feed,
          id: this.id
        })
        .then(res => {
          console.log(res);
        })
        .catch(err => {
          console.error(err);
        });
    },
    getQuestion() {
      this.axios
        .post(this.$store.state.apiUrl + "Read/editquestion.php", {
          token: localStorage.getItem("token"),
          id_question: this.$route.params.id_question
        })
        .then(res => {
          this.question = res.data.data.question;
          this.answer = res.data.data.answer;
          this.pageURL = res.data.data.p_url;
          this.questionType = res.data.data.qtype;
          this.expiry_date = res.data.data.expiry_date;
          this.expiry_hour = parseInt(
            res.data.data.expiry_date.split(" ")[1].split(":")[0]
          );
          this.record_feed = res.data.data.hideqa;
          this.id = res.data.data.q_id;
          setTimeout(function() {
            $(".ui.dropdown").dropdown();
          }, 100);
        })
        .catch(err => {
          console.error(err);
        });
    }
  },
  beforeMount() {
    this.getQuestion();
  },
  mounted() {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/QAEdit.vue